/**
 * Độ rộng tìm nhanh của combobox theo thiết lập hiển thị
 * NVTUAN1 20.11.2023
 */
export default {
  HeightSmall: 26,
  HeightBig: 36,
};